import { CustomTooltip } from 'common-ui/table/CustomTooltip';

import {
  CardBody,
  CardContent,
  CardGroupWrapper,
  CardHeader,
  CardItem,
  CardLabel,
  EmptyData,
  InfoCard,
  Key,
  Span,
  Value,
} from './Components.styles';

export const Card = ({ action, data, title, additional, setShowCompetitorInfo }) => {
  const truncateText = (text, maxLength = 40) => {
    if (text.length > 40) {
      return (
        <CustomTooltip title={text}>
          <Span>{text.slice(0, maxLength) + '...'}</Span>
        </CustomTooltip>
      );
    }
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  return (
    <InfoCard>
      <CardHeader>
        <CardLabel>{title}</CardLabel>
        {action}
      </CardHeader>
      <CardContent>
        <CardBody>
          {Array.isArray(data) && data.length > 0 ? (
            data.map((groupData, index) => {
              let visibleIndex = 0;

              return (
                <CardGroupWrapper
                  key={index}
                  $isSelected={groupData.isSelected}
                  onClick={groupData.onClick}
                  $isLast={index === data.length - 1}
                >
                  {groupData.group.map((elm, i) => {
                    if (!elm?.value) return null;
                    const isBlueText =
                      elm.label === 'Company' ||
                      elm.label === 'Full name' ||
                      elm.label === 'Offer name' ||
                      elm.label === 'Name';
                    const bgColor = visibleIndex % 2 === 0 ? '#ECF1FB' : undefined;
                    visibleIndex++;

                    return (
                      <CardItem key={i} $color={bgColor}>
                        <Key>{elm.label}</Key>
                        <Value $textColor={isBlueText ? '#2D6CDF' : undefined}>
                          {typeof elm.value === 'string' && elm.value.includes('<') ? (
                            <Span dangerouslySetInnerHTML={{ __html: elm.value }} />
                          ) : (
                            truncateText(elm.value)
                          )}
                        </Value>
                      </CardItem>
                    );
                  })}
                </CardGroupWrapper>
              );
            })
          ) : (
            <EmptyData>
              <Key>No data available</Key>
            </EmptyData>
          )}
        </CardBody>

        {additional && (
          <CardItem>
            <Key>Competitor info</Key>
            <Value $underline={true} onClick={() => setShowCompetitorInfo()}>
              View
            </Value>
          </CardItem>
        )}
      </CardContent>
    </InfoCard>
  );
};
